<script>
    import './dutchAuction.css'
    import {defaultEvmStores, signerAddress} from 'svelte-ethers-store'
    import {metaMaskExtensionInstallationLink} from "../../../constants/constants";
    import Sidebar from "./sidebar/Sidebar.svelte";
    import ProjectDetail from "./project-detail/ProjectDetail.svelte";
    import Redeemable from "./redeemable/Redeemable.svelte";
    let step = 2
</script>

{#if $signerAddress}
    <div id="dutch-auction" class="permissionless-wrapper flex flex-wrap">
        <div class="container">
            <div class="permissionless-content-wrapper flex items-start">
                <div class="pl-sidebar-wrap flex flex-wrap column-direction">
                    <Sidebar sidebarStep={step} />
                </div>
                <div class="pl-content-wrapper">
                    {#if step === 1}
                        <ProjectDetail on:next={() => step = 2}/>
                    {:else if step === 2}
                        <Redeemable on:next={() => step = 3} on:back={() => step = 1}/>
                    {:else if step === 3}

                    {:else if step === 4}

                    {/if}
                </div>
            </div>
        </div>
    </div>
{:else}
    <div class="connect-wallet-wrapper flex flex-text-center items-center column-direction">
        <img src="./images/meta.svg" alt="image">
        <p>Please Connect Metamask and Select the Polygon network to get started.</p>
        <button class="btn-gradient-border btn-start-project" on:click={
    () => {
        defaultEvmStores.setProvider().catch( () => {
           setTimeout(
                () =>
                  window.open(metaMaskExtensionInstallationLink, "_blank"),
                1000
           );
        })
    }
  }>Connect Wallet</button>
    </div>
{/if}
